<a [finLink]="url" class="block nordic-blue-900-text text-icon-primary medium-type no-underline" data-testid="link-cta">
  <span>{{ text }}</span>
  <fcom-icon [name]="SvgLibraryIcon.ARROW_RIGHT" />
</a>
